export default "__VITE_ASSET__BOzdpK_M__"